






import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class PresentationPrint extends Vue {

  created() {
    const el: any = document.body;
    el.classList.add('print');
    el.parentElement.classList.add('print');
  }

  destroyed() {
    const el: any = document.body;
    el.classList.remove('print');
    el.parentElement.classList.remove('print');
  }
}
